import React from "react";

const ConfirmDialog = ({ open, onClose, onSubmit, title, content, submit, exit, color }) => {
  if (!open) return null;

  const getButtonClass = () => {
    if (color === "error") return "btn btn-danger";
    return "btn btn-primary";
  };

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1070 }} />
      <div className="modal modal-blur fade show d-block" style={{ zIndex: 1075 }} tabIndex="-1">
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <h3 className="mb-3">{title}</h3>
              <p className="text-secondary">{content}</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-link link-secondary me-auto" onClick={onClose}>
                {exit}
              </button>
              <button className={getButtonClass()} onClick={onSubmit}>
                {submit}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;
